/**
 * Campos de contexto urbano del lote (getmylots / getalllots con prefijo `lot_`).
 * @see docs/maps/lot-detail-field-parity.md
 */
export const pickLotContextFields = (source = {}) => ({
  lot_shape: source.lot_shape ?? null,
  front_highway_type: source.front_highway_type ?? source.lot_front_highway_type ?? null,
  street_position: source.street_position ?? source.lot_street_position ?? null,
  neighborhood_type: source.neighborhood_type ?? source.lot_neighborhood_type ?? null,
  front_azimuth: source.front_azimuth ?? source.lot_front_azimuth ?? null,
});

export const mergeLotContextFields = (primary = {}, ...fallbacks) => {
  const merged = pickLotContextFields(primary);
  const keys = Object.keys(merged);

  return keys.reduce((acc, key) => {
    if (merged[key] != null && merged[key] !== '') {
      acc[key] = merged[key];
      return acc;
    }

    for (const source of fallbacks) {
      const value = pickLotContextFields(source)[key];
      if (value != null && value !== '') {
        acc[key] = value;
        return acc;
      }
    }

    acc[key] = null;
    return acc;
  }, {});
};
